import VueCookies from 'vue-cookies';
const DOMAIN = import.meta.env.VITE_DOMAIN;
VueCookies.config(null, '/', `.${DOMAIN}`);

export function getItem(key) {
  const item = VueCookies.get(key);
  return item;
}

export function setItem(key, value, { expires } = {}) {
  VueCookies.set(key, value, expires);
}

export function removeItem(key) {
  VueCookies.remove(key);
}

export function removeAll() {
  VueCookies.keys().forEach((cookieName) => {
    VueCookies.remove(cookieName);
  });
}
